import React from 'react';
import { connect } from 'react-redux';
import NavigationItem from './NavigationItem/NavigationItem';

import flightImage from './img/flight.svg';
import hotelImage from './img/hotel.svg';
import holidayImage from './img/holiday.svg';
import trainImage from './img/train.svg';
import activitiesImage from './img/activities.svg';
import adventureImage from './img/adventure.svg';
import insuranceImage from './img/insurance.svg';

const navigationItems = (props) => {

    let flights = false;
    let hotels = false;
    let trains = false;
    let activities = false;
    let adventures = false;
    let holiday = false;
    let utility = false;
    let dmt = false;
    let insurance = false;

    if (props.productAccess) {
        let pA = props.productAccess.productConfig;
        if (Number(pA['dom-flights']) === 1 || Number(pA['int-flights']) === 1) { flights = true; }
        if (Number(pA[`dom-hotels`]) === 1 || Number(pA['int-hotels']) === 1) { hotels = true; }
        if (Number(pA.trains === 1)) { trains = true; }
        if (Number(pA.activities === 1)) { activities = true; }
        if (Number(pA.adventures === 1)) { adventures = true; }
        if (Number(pA['dom-holidays']) === 1 || Number(pA['int-holidays']) === 1) { holiday = true; }
        if (Number(pA.utility === 1)) { utility = true; }
        if (Number(pA.dmt === 1)) { dmt = true; }
        if (Number(pA.insurace === 1) || Number(pA['int-insurance']) === 1 || pA['general-insurance']) { insurance = true; }
    }

    return (
        <ul className={`u-overflowHiddenX`}>
            { <NavigationItem link="/flights" image={flightImage} navigationItemActive={props.navigationItemsActive}>Flights</NavigationItem> }
            { <NavigationItem link="/hotels" image={hotelImage} navigationItemActive={props.navigationItemsActive}>Hotels</NavigationItem> }
            { <NavigationItem link="/trains" image={trainImage} navigationItemActive={props.navigationItemsActive}>Trains</NavigationItem> }
            { <NavigationItem link="/activities" image={activitiesImage} navigationItemActive={props.navigationItemsActive}>Activities</NavigationItem> }
            { <NavigationItem link="/adventures" image={adventureImage} navigationItemActive={props.navigationItemsActive}>Adventure</NavigationItem> }
            { <NavigationItem link="/holidays" image={holidayImage} navigationItemActive={props.navigationItemsActive}>Holidays</NavigationItem> }
            { <NavigationItem link="/utility" image={hotelImage} navigationItemActive={props.navigationItemsActive}>Utility</NavigationItem> }
            { <NavigationItem link="/dmt" image={hotelImage} navigationItemActive={props.navigationItemsActive}>DMT</NavigationItem> }
            { <NavigationItem link="/insurance" image={insuranceImage} navigationItemActive={props.navigationItemsActive}>Insurance</NavigationItem> }
        </ul>
    )
}

const mapStateToProps = state => {
    return {
        productAccess: state.auth.userProductAccess
    }
}

export default connect(mapStateToProps)(navigationItems);


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItems.js